import React, { useState } from 'react';
import { metricHeading, metricKey, monthLabel } from './format';

// Statistic / period / rolling / summary picker; chosen metrics become grid columns.
// Period "custom" adds a From month-end (the screen's As at is the To month).
export function MetricForm({ catalogue, asAtDates, onAdd, buttonLabel = 'Add column', initial }) {
  const [stat, setStat] = useState(initial?.statistic || 'excess_return');
  const [period, setPeriod] = useState(initial?.period || '3y');
  const [start, setStart] = useState(initial?.start || '');
  const [rolling, setRolling] = useState(initial?.rolling ? String(initial.rolling) : '');
  const [summary, setSummary] = useState(initial?.summary || 'latest');
  const def = catalogue?.statistics?.find((s) => s.key === stat);
  const submit = () => {
    if (period === 'custom' && !start) return;
    onAdd({ statistic: stat, period, start: period === 'custom' ? start : undefined, rolling: rolling ? Number(rolling) : null, summary: rolling ? summary : 'latest' });
  };
  if (!catalogue) return null;
  return (
    <div className="qs-metric-form">
      <select value={stat} onChange={(e) => setStat(e.target.value)} title={def?.description}>
        {catalogue.statistics.map((s) => (
          <option key={s.key} value={s.key}>{s.label}{s.direction === 0 ? ' (context)' : ''}</option>
        ))}
      </select>
      <select value={period} onChange={(e) => setPeriod(e.target.value)}>
        {catalogue.periods.map((p) => <option key={p} value={p}>{p === 'si' ? 'since inception' : p === 'custom' ? 'custom (from…)' : p}</option>)}
      </select>
      {period === 'custom' && (
        <select value={start} onChange={(e) => setStart(e.target.value)} title="From month-end; the screen's As at is the To month">
          <option value="">from…</option>
          {(asAtDates || []).map((d) => <option key={d} value={d}>{monthLabel(d)}</option>)}
        </select>
      )}
      <select value={rolling} onChange={(e) => setRolling(e.target.value)}>
        <option value="">point</option>
        {catalogue.rolling_windows.map((w) => <option key={w} value={w}>rolling {w}m</option>)}
      </select>
      <select value={summary} onChange={(e) => setSummary(e.target.value)} disabled={!rolling}>
        {catalogue.summaries.map((s) => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}
      </select>
      <button type="button" className="qs-btn" onClick={submit}>{buttonLabel}</button>
      {def && <div className="qs-metric-help">{def.description}{def.needs_benchmark ? ' Needs the AP List benchmark.' : ''}{def.needs_rf ? ' Uses the risk-free proxy.' : ''}</div>}
    </div>
  );
}

export default function MetricPicker({ catalogue, asAtDates, metrics, setMetrics }) {
  const add = (m) => {
    const key = metricKey(m);
    if (metrics.some((x) => metricKey(x) === key)) return;
    setMetrics([...metrics, m]);
  };
  const remove = (key) => setMetrics(metrics.filter((x) => metricKey(x) !== key));
  return (
    <div className="qs-metrics">
      <div className="qs-chips">
        {metrics.map((m) => {
          const key = metricKey(m);
          return (
            <span key={key} className="qs-chip">
              {metricHeading(m, catalogue)}
              <button type="button" className="qs-chip-x" onClick={() => remove(key)} aria-label="remove">×</button>
            </span>
          );
        })}
        {metrics.length === 0 && <span className="qs-muted">No statistic columns yet (score columns still show when a weighting set is on).</span>}
      </div>
      <MetricForm catalogue={catalogue} asAtDates={asAtDates} onAdd={add} />
    </div>
  );
}
